import { render, staticRenderFns } from "./StandaloneDocumentViewer.vue?vue&type=template&id=7d11e5f6&scoped=true"
import script from "./StandaloneDocumentViewer.vue?vue&type=script&lang=js"
export * from "./StandaloneDocumentViewer.vue?vue&type=script&lang=js"
import style0 from "./StandaloneDocumentViewer.vue?vue&type=style&index=0&id=7d11e5f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d11e5f6",
  null
  
)

export default component.exports